export default __webpack_public_path__ + "locales/es/PeopleTranslations.json?hash=441de9877accb87e290c575b577099c5";